window.SingleProduct = {
  // --- Configuration & State ---
  quantity: 1,
  productPrice: 0, // Store the product price in cents
  elements: { // DOM element references
    section: null,
    form: null,
    quantityInput: null,
    quantityDecrease: null,
    quantityIncrease: null,
    mainPriceDisplay: null,
    perPiecePriceDisplay: null,
    totalPriceDisplay: null,
    addToCartButton: null,
  },

  // --- Initialization ---
  init: function(sectionElement) {
    this.elements.section = sectionElement;
    if (!this.elements.section) {
      console.error('SingleProduct: Section element not provided for init.');
      this.elements.section = document.querySelector('.single-product[data-section-id]');
      if (!this.elements.section) {
        console.error('SingleProduct: Product section container (.single-product) not found.');
        return;
      }
    }

    // Find DOM elements
    this.elements.form = this.elements.section.querySelector('product-page form, form[data-type="add-to-cart-form"]');
    this.elements.quantityInput = this.elements.section.querySelector('.single-product__quantity-input');
    this.elements.quantityDecrease = this.elements.section.querySelector('.single-product__quantity-button:first-child');
    this.elements.quantityIncrease = this.elements.section.querySelector('.single-product__quantity-button:last-child');
    this.elements.mainPriceDisplay = this.elements.section.querySelector('.single-product__main-price');
    this.elements.perPiecePriceDisplay = this.elements.section.querySelector('.single-product__per-piece-price');
    this.elements.totalPriceDisplay = this.elements.section.querySelector('.single-product__total-price');
    this.elements.addToCartButton = this.elements.section.querySelector('.single-product__add-to-cart');

    // Get initial quantity
    if (!this.elements.quantityInput) {
      console.warn('SingleProduct: Quantity input not found. Defaulting quantity to 1.');
      this.quantity = 1;
    } else {
      this.quantity = parseInt(this.elements.quantityInput.value) || 1;
    }

    // Get product price from main price display
    this.extractProductPrice();

    this.addEventListeners();
    this.updatePerPiecePrice();
    this.updateTotalPrice();
    this.setupAccessibility();
    this.hideNoReviewsText();
    
    console.log('SingleProduct initialized for section:', this.elements.section.dataset.sectionId);
  },

  extractProductPrice: function() {
    if (this.elements.mainPriceDisplay) {
      const priceText = this.elements.mainPriceDisplay.textContent.trim();
      // Extract price from text like "$12.99" and convert to cents
      const priceMatch = priceText.match(/[\d,]+\.?\d*/);
      if (priceMatch) {
        const priceString = priceMatch[0].replace(/,/g, '');
        this.productPrice = Math.round(parseFloat(priceString) * 100); // Convert to cents
      }
    }
  },

  addEventListeners: function() {
    // Quantity input changes
    if (this.elements.quantityInput) {
      this.elements.quantityInput.addEventListener('change', this.handleQuantityChange.bind(this));
      this.elements.quantityInput.addEventListener('input', this.handleQuantityChange.bind(this));
    }

    // Quantity decrease button
    if (this.elements.quantityDecrease) {
      this.elements.quantityDecrease.addEventListener('click', (e) => {
        e.preventDefault();
        this.decreaseQuantity();
      });
    }

    // Quantity increase button
    if (this.elements.quantityIncrease) {
      this.elements.quantityIncrease.addEventListener('click', (e) => {
        e.preventDefault();
        this.increaseQuantity();
      });
    }

    // Add to cart button
    if (this.elements.addToCartButton) {
      this.elements.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    }
  },

  handleQuantityChange: function(event) {
    const newQuantity = parseInt(event.target.value);
    if (isNaN(newQuantity) || newQuantity < 1) {
      this.quantity = 1;
      if (this.elements.quantityInput) this.elements.quantityInput.value = 1;
    } else {
      this.quantity = newQuantity;
    }
    this.updateTotalPrice();
  },

  decreaseQuantity: function() {
    if (this.quantity > 1) {
      this.quantity--;
      if (this.elements.quantityInput) {
        this.elements.quantityInput.value = this.quantity;
      }
      this.updateTotalPrice();
    }
  },

  increaseQuantity: function() {
    this.quantity++;
    if (this.elements.quantityInput) {
      this.elements.quantityInput.value = this.quantity;
    }
    this.updateTotalPrice();
  },

  updatePerPiecePrice: function() {
    if (this.elements.perPiecePriceDisplay && this.productPrice > 0) {
      // Get pack quantity from metafield data
      const packQuantity = parseInt(this.elements.perPiecePriceDisplay.dataset.packQuantity) || 1;
      
      // Show per-piece display
      this.elements.perPiecePriceDisplay.style.display = 'block';
      
      if (packQuantity <= 1) {
        // Single item or no metafield - show "each"
        this.elements.perPiecePriceDisplay.textContent = 'each';
      } else {
        // Multiple pieces - show per-piece price and count
        const unitPrice = this.productPrice / packQuantity;
        const unitPriceFormatted = this.formatMoney(unitPrice);
        this.elements.perPiecePriceDisplay.textContent = `${unitPriceFormatted} pc · ${packQuantity} pieces`;
      }
    }
  },

  updateTotalPrice: function() {
    if (this.elements.totalPriceDisplay && this.productPrice > 0) {
      const totalPrice = this.productPrice * this.quantity;
      const totalPriceFormatted = this.formatMoney(totalPrice);
      
      // Simple total price display without piece count
      this.elements.totalPriceDisplay.textContent = totalPriceFormatted;
    }
  },

  formatMoney: function(cents) {
    // Basic money formatting - in a real implementation, use Shopify.formatMoney
    const dollars = cents / 100;
    return `$${dollars.toFixed(2)}`;
  },

  handleAddToCart: function(event) {
    event.preventDefault();
    
    // Submit the form if it exists
    if (this.elements.form) {
      // Update quantity in form
      const formQuantityInput = this.elements.form.querySelector('input[name="quantity"]');
      if (formQuantityInput) {
        formQuantityInput.value = this.quantity;
      }

      // Submit form - let theme handle the cart addition
      this.elements.form.submit();
    } else {
      console.warn('SingleProduct: No form found for add to cart submission.');
    }
  },

  setupAccessibility: function() {
    // Set up quantity input accessibility
    if (this.elements.quantityInput) {
      this.elements.quantityInput.setAttribute('aria-label', 'Quantity');
      this.elements.quantityInput.setAttribute('min', '1');
    }

    if (this.elements.quantityDecrease) {
      this.elements.quantityDecrease.setAttribute('aria-label', 'Decrease quantity');
    }

    if (this.elements.quantityIncrease) {
      this.elements.quantityIncrease.setAttribute('aria-label', 'Increase quantity');
    }
  },

  // --- Hide "No reviews" Text ---
  hideNoReviewsText: function() {
    const ratingCaption = this.elements.section.querySelector('.star-rating__caption');
    if (ratingCaption && ratingCaption.textContent.trim() === 'No reviews') {
      ratingCaption.style.display = 'none';
      console.log('SingleProduct: "No reviews" text hidden');
    }
  },

};

// --- Initialization Trigger ---
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.single-product[data-section-id]').forEach(sectionElement => {
      const singleProductInstance = Object.create(window.SingleProduct);
      singleProductInstance.init(sectionElement);
    });
  });
} else {
  document.querySelectorAll('.single-product[data-section-id]').forEach(sectionElement => {
    const singleProductInstance = Object.create(window.SingleProduct);
    singleProductInstance.init(sectionElement);
  });
}

// Shopify Theme Editor Support
document.addEventListener('shopify:section:load', function(event) {
  const sectionElement = event.target.querySelector('.single-product[data-section-id]');
  if (sectionElement && event.detail.sectionId === sectionElement.dataset.sectionId) {
    const singleProductInstance = Object.create(window.SingleProduct);
    singleProductInstance.init(sectionElement);
  }
});

document.addEventListener('shopify:section:unload', function(event) {
  // Cleanup if needed - remove event listeners, clear references
  const sectionElement = event.target.querySelector('.single-product[data-section-id]');
  if (sectionElement) {
    // Mark as uninitialized to prevent memory leaks
    delete sectionElement.dataset.singleProductInitialized;
  }
});